import { useNavigate } from 'react-router-dom';

export const useNavigateExternal = () => {
  const navigate = useNavigate();

  return (to: string) => {
    if (to.startsWith('/')) {
      navigate(to);

      return;
    }

    window.location.href = to;
  };
};
